import PropTypes from 'prop-types';

import { Heading } from '@spotahome/ui-library';

const SectionHeading = ({
  text,
  size = 'large',
  level = 2,
  theme = 'dark',
  type = 'uppercase',
  align = 'center'
}) => (
  <Heading
    size={size}
    text={text}
    className="mb-xl"
    level={level}
    theme={theme}
    type={type}
    align={align}
  />
);

SectionHeading.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.string,
  level: PropTypes.number,
  theme: PropTypes.string,
  type: PropTypes.string,
  align: PropTypes.string
};

export default SectionHeading;
